import { ReactNode } from 'react';
import { View } from 'react-native';
import { clsx } from 'clsx';
import { Props } from 'shared/@types';
import { Text } from 'shared/components/text';

export const QuoteCard = ({
  children,
  footer,
  size = 'default',
  className,
  contentClassName,
}: Props<{
  footer?: ReactNode;
  size?: 'default' | 'large';
  contentClassName?: string;
}>) => {
  const isLarge = size === 'large';

  return (
    <View
      className={clsx(
        'border-brand-brown-dark/10 relative overflow-hidden rounded-lg border bg-white/80',
        isLarge ? 'p-6 md:p-9' : 'p-4',
        className,
      )}
    >
      <Text
        className={clsx(
          'text-brand-brown-dark/15 absolute z-0 font-black leading-none',
          isLarge ? 'left-2 top-1 text-7xl md:text-8xl' : 'left-2 top-1 text-6xl',
        )}
      >
        {'“'}
      </Text>

      <View className={clsx('relative z-10', contentClassName)}>{children}</View>

      {footer && (
        <View className={'border-brand-brown-dark/10 relative z-10 mt-4 border-t pt-3'}>
          {footer}
        </View>
      )}
    </View>
  );
};
